<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productPallet.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productPallet.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner
          :loading="loading"
        >
          <div class="max-h">
            <table class="ts-w-full">
              <thead>
                <tr>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-4 ts-text-center">{{ $t('productPallet.no') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-48">{{ $t('productPallet.barcode') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">{{ $t('productPallet.productName') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-20">{{ $t('productPallet.uomName') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-48">{{ $t('productPallet.qtyPerPallet') }}</th>
                <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-48">{{ $t('productPallet.qtyFocPerXUnit') }}</th>
              </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(p, index) in model.product_list"
                  :key="index"
                  class="ts-border-b"
                >
                  <td class="ts-text-center">{{ index + 1 }}</td>
                  <td class="ts-px-2 ts-py-1">{{ p.barcode }}</td>
                  <td class="ts-px-2 ts-py-1">{{ p.product_name_en }}</td>
                  <td class="ts-px-2 ts-py-1 ts-text-center">{{ p.uom_name_en }}</td>
                  <td class="ts-px-2 ts-py-1">
                    <input 
                      v-model.number="p.quantity_per_pallet"
                      type="number"
                      class="ts-px-2 ts-py-1 ts-bg-gray-200 ts-outline-none"
                    >
                  </td>
                  <td class="ts-px-2">
                    <input 
                      v-model.number="p.qty_foc_per_x_unit"
                      type="number"
                      class="ts-px-2 ts-py-1 ts-bg-gray-200 ts-outline-none"
                    >
                  </td>
                </tr>
              </tbody>
              <tfoot>
                              <tr>
                <td class="ts-bg-blue-600" colspan="6"></td>
              </tr>
                <tr>
                  <td class="ts-text-center ts-whitespace-no-wrap ts-font-bold">
                    {{ $t('productPallet.row#') + ' '+ model.product_list.length  }}
                  </td>
                  <td colspan="3" class="ts-text-right ts-uppercase ts-font-bold">{{ $t('productPallet.total') }}</td>
                  <td class="ts-font-bold ts-px-4 ts-py-1">{{ sumPerPallet }}</td>
                  <td class="ts-font-bold ts-px-4 ts-py-1">{{ sumFocPerX }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="ts-flex ts-justify-end ts-space-x-3">
            <ts-button
              @click="$router.push({ name: 'product-pallet' })"
            >{{ $t('cancel') }}</ts-button>
            <ts-button
              :waiting="waiting"
              color="primary"
              @click="onStore"
            >{{ $t('saveChange') }}</ts-button>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'productPalletEdit',
  data() {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      model: {
        product_list: []
      }
    }
  },
  computed: {
    sumPerPallet() {
      return _.sumBy(this.model.product_list, 'quantity_per_pallet')
    },
    sumFocPerX() {
      return _.sumBy(this.model.product_list, 'qty_foc_per_x_unit')
    }
  },
  methods: {
    ...mapActions('product/pallet', ['getProduct', 'store']),
    fetchProduct(){
      this.loading = true
      this.getProduct()
        .then(response => {
          this.model.product_list = response.data.map(el => ({
            barcode: el.barcode,
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            qty_foc_per_x_unit: el.qty_foc_per_x_unit ? el.qty_foc_per_x_unit : 0,
            quantity_per_pallet: el.quantity_per_pallet ? el.quantity_per_pallet : 0,
            uom_id: el.uom_id,
            uom_name_en: el.uom_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.messsage)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onStore(){
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.messsage)
           this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  beforeRouteEnter(to, from, next ){
    next(vm => {
      vm.fetchProduct()
    })
  }
}
</script>

<style scoped>
.max-h {
  height: 70vh;
  max-height: 75vh;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  /* border-spacing: 0;  */
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}
</style>